export default "__VITE_ASSET__BULApluV__"